// 🔴 SECURITY (Wave 1A, 2026-04-29) — settings 파일 인증 다운로드 헬퍼
// 신규 endpoint: GET /api/settings/file/:type?cid=N (routes/settings.js)
// 정적 마운트 (server.js:864) 는 Wave 1B 클라이언트 마이그 완료 후 제거 예정.
//
// 사용 패턴 (Wave 1B):
//   var url = settingsFileUrl('signature', companyId);
//   var blobUrl = await fetchSettingsFileBlob('signature', companyId);
//   <img src={blobUrl} />
//   ★ useEffect cleanup 에서 URL.revokeObjectURL(blobUrl) 호출 필수 (메모리 누수 방지)
//
// RN (autodex-app):
//   <Image source={{ uri: settingsFileUrl(...), headers: { Authorization: 'Bearer ' + token } }} />
//   RN 은 Image source.headers 옵션 지원 → blob 없이도 인증 가능

import { API, authFetch } from './api';

var TYPE_LIST = ['signature', 'stamp', 'business-license'];

/**
 * 인증된 settings 파일 다운로드 URL 빌더.
 * @param {string} type — 'signature' | 'stamp' | 'business-license'
 * @param {number|null} companyId — null/undefined 이면 백엔드가 active 회사 fallback
 * @param {object} [opts] — { bust: boolean } true 시 ?_t=Date.now() 캐시 무효화 추가
 * @returns {string} URL (Authorization 헤더 별도 필요)
 */
export function settingsFileUrl(type, companyId, opts) {
  if (TYPE_LIST.indexOf(type) < 0) throw new Error('invalid settings file type: ' + type);
  var url = API + '/settings/file/' + type;
  var qs = [];
  if (companyId !== null && companyId !== undefined && companyId !== '') {
    qs.push('companyId=' + parseInt(companyId, 10));
  }
  if (opts && opts.bust) qs.push('_t=' + Date.now());
  if (qs.length) url += '?' + qs.join('&');
  return url;
}

/**
 * settings 파일을 fetch + blob URL 변환.
 * ★ 호출자는 useEffect cleanup 에서 URL.revokeObjectURL(blobUrl) 필수 — 메모리 누수 방지.
 * ★ RN 은 본 함수 대신 <Image source={{ uri, headers: { Authorization } }}> 사용 권장.
 * @param {string} type
 * @param {number|null} companyId
 * @returns {Promise<string>} blob: URL
 * @throws {Error} 401/403/404/네트워크 오류 시
 */
export async function fetchSettingsFileBlob(type, companyId) {
  var url = settingsFileUrl(type, companyId);
  var r = await authFetch(url, { cache: 'no-store' });
  if (!r.ok) throw new Error('settings file fetch ' + r.status);
  var blob = await r.blob();
  return URL.createObjectURL(blob);
}

export default settingsFileUrl;
